// extracted by mini-css-extract-plugin
export var productImage = "_qt-1";
export var viewLink = "_qt-2";
export var wishlistItem = "_qt-0";